import React from 'react';

const HorizontalScrollView = ({ children }) => {
  return (
    <div className="horizontal-scroll-view">
      <div className="scroll-container">
        {children}
      </div>
    </div>
  );
};

export default HorizontalScrollView;
